import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import { LiraLazySlotVehicleHistory } from '@/client/components/Adv/Lira/LiraLazySlotVehicleHistory';
import { useAdvToggle } from '@/client/hooks/useAdvToggle';
import FeatureList, { Feature } from '../../FeatureList';
import type { SectionProps } from './section';
import ownClasses from './style/vehicle-history-section.module.scss';
type Props = SectionProps & {
  features: Feature[];
};
export function VehicleHistorySection(t0) {
  const $ = _c(18);
  const {
    features,
    classes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  const {
    noAdvToggle,
    optimizelyReady
  } = useAdvToggle();
  let t3;
  if ($[2] !== classes) {
    t3 = cn(ownClasses["vehicle-history"], classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className={cn("headline-6", ownClasses["vehicle-history-title"])}>Informazioni di base</h2>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== noAdvToggle || $[6] !== optimizelyReady) {
    t5 = optimizelyReady && noAdvToggle !== "B" && <LiraLazySlotVehicleHistory containerId={LiraContainerIds.adView.vehicleHistory} cssClass={ownClasses["vehicle-history-adv"]} />;
    $[5] = noAdvToggle;
    $[6] = optimizelyReady;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== features) {
    t6 = <FeatureList features={features} />;
    $[8] = features;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== noAdvToggle || $[11] !== optimizelyReady) {
    t7 = optimizelyReady && noAdvToggle !== "B" && <LiraLazySlotVehicleHistory containerId={LiraContainerIds.adView.vehicleHistory2} cssClass={ownClasses["vehicle-history-adv-2"]} />;
    $[10] = noAdvToggle;
    $[11] = optimizelyReady;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <section className={t3}>{t4}{t5}{t6}{t7}</section>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
export default VehicleHistorySection;